export default __webpack_public_path__ + "static/media/icon3.3dc8c77b.svg";